// extracted by mini-css-extract-plugin
module.exports = {"ChannelConstract":"index-module_ChannelConstract_2v7YK","rightIcon":"index-module_rightIcon_2mG9N"};